import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            <h4>Sorry this page is not found .................</h4>
        </div>
    );
};

export default NotFound;